<!-- <div class="view-container"> -->
<!-- <div class="brands"> -->
<mat-card>
  <mat-card-content>
    <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
      fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
      <label>Your Brands</label>
      <button mat-flat-button type="button" color="accent" (click)="onOpenAddBrands()" matTooltip="Add Brand">
        <mat-icon>add</mat-icon>Add Brands
      </button>
    </div>
    <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
      <mat-card-content>
        <div class="filter" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
          <mat-form-field>
            <mat-label>Filter by name</mat-label>
            <input matInput type="text" [formControl]="nameFilterControl" name="brand Name">
          </mat-form-field>
        </div>
      </mat-card-content>
    </mat-card>

    <div>
      <div class="header-row" fxHide.lt-md>
        <div>Brand</div>
        <div>Brand Logo</div>
        <div [ngStyle.gt-md]="{ 'justify-self': 'center' }">Hide Company Logo</div>
        <div>Quality Level</div>
        <div [ngStyle.gt-md]="{ 'justify-self': 'end' }">Edit</div>
      </div>
      <ng-container *ngFor="let brandRow of filteredBrands | async">
        <div class="brand-row" [ngClass]="{'editing': brandRow.editMode}" 
        gdColumns.lt-md="1fr 1fr" gdColumns.lt-sm="1fr" gdAlign.lt-md="start">
          <!-- Display Brand-->
          <ng-container *ngIf="!brandRow.editMode">
            <small fxHide.gt-sm>Name</small>
            <span>{{brandRow.brand.name}}</span>
            <small fxHide.gt-sm>Logo</small>
            <img class="product-brand-logo" alt="Brand Logo"
              [src]="brandRow.brand.brandLogoUrl || '/assets/images/no-image-icon.svg'">
            <small fxHide.gt-sm>Hide Company Logo</small>
            <mat-checkbox [ngStyle.gt-md]="{ 'justify-self': 'center' }" disabled [(ngModel)]="brandRow.brand.showBrandLogoOnly"></mat-checkbox>
            <small fxHide.gt-sm>Quality Level</small>
            <span>{{ QualityLevel[brandRow.brand.qualityLevel] || "Unset" }}</span>
            <div class="actions">
              <button mat-icon-button (click)="onEditBrand(brandRow)" matTooltip="Edit Brand">
                <mat-icon>edit</mat-icon></button>
            </div>
          </ng-container>

          <!-- Edit Brand -->
          <ng-container *ngIf="brandRow.editMode">
            <mat-form-field>
              <mat-label>Brand Name</mat-label>
              <input matInput [formControl]="brandRow.form.controls.name">
            </mat-form-field>
            <mat-menu #imageMenu="matMenu">
              <select-logo-menu 
              [parent]="imageMenu"
              [(uri)]="brandRow.brand.brandLogoUrl"
              [(logoId)]="brandRow.logoId"
              [companyId]="selectedCompany?.id"></select-logo-menu>
            </mat-menu>
            <button class="image-placeholder" mat-button #menuTrigger="matMenuTrigger"
            [ngClass]="{'empty': !brandRow.brand?.brandLogoUrl}" 
            [matMenuTriggerFor]="imageMenu">
              <span *ngIf="!brandRow.brand?.brandLogoUrl">Select Logo</span>
              <img *ngIf="brandRow.brand?.brandLogoUrl" [src]="brandRow.brand?.brandLogoUrl">
            </button>
            <mat-checkbox [ngStyle.gt-md]="{ 'justify-self': 'center' }" [formControl]="brandRow.form.controls.showBrandLogoOnly"></mat-checkbox>
            <mat-button-toggle-group [style.width]="'fit-content'" [formControl]="brandRow.form.controls.qualityLevel">
              <ng-container *ngFor="let quality of QualityLevel | enumKeyValue">
                <mat-button-toggle [value]="quality.value">{{quality.key}}</mat-button-toggle>
              </ng-container>
            </mat-button-toggle-group>
            <div class="actions">
              <button mat-icon-button color="warn" (click)="onDeleteBrand(brandRow)" matTooltip="Delete Brand"><mat-icon>delete</mat-icon></button>
              <button mat-icon-button color="primary" (click)="onSaveChanges(brandRow)" matTooltip="Save Changes"><mat-icon>save</mat-icon></button>
              <button mat-icon-button (click)="brandRow.editMode = false"
                matTooltip="Cancel Editing"><mat-icon>cancel</mat-icon></button>
            </div>
            </ng-container>
            
            </div>
      </ng-container>
    </div>
  </mat-card-content>
</mat-card>